import { addressBookStyles } from "@insite/content-library/Widgets/Addresses/AddressBook";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

Object.assign(addressBookStyles, {
    ...addressBookStyles,
    titleText: {
        variant: "h3",
        css: css`
            width: 100%;
            font-size: 22px;
            padding-bottom: 2px;
            margin: 0;
            color: #252525;
            border-bottom: none;
            text-transform: none;
        `,
    },
    addressCard: {
        gridContainer: { gap: 20 },
        addressInfoDisplayGridItem: { width: [10, 10, 5, 7, 7] },
        actionsGridItem: {
            width: [2, 2, 7, 5, 5],
            css: css`
                justify-content: flex-end;
            `,
        },
        actionUseAsShippingAddressButton: {
            variant: "primary",
            css: css`
                :hover {
                    background-color: #ab161a;
                    border-color: #ab161a;
                }
            `,
        },
        actionEditLink: {
            css: css`
                display: block;
                margin: 20px auto 0 auto;
            `,
        },
        bottomBorderGridItem: { width: 12 },
        bottomBorder: {
            css: css`
                height: 1px;
                background-color: ${getColor("common.border")};
                width: 100%;
            `,
        },
        overflowMenu: {
            cssOverrides: {
                menu: css`
                    width: 210px;
                `,
            },
        },
    },
});
